import { useState, useCallback, useEffect } from 'react';
import { FixedSizeList as List } from 'react-window';

export const Lista = ({ altura, largoItem, cantidadTotal, children, anchoColumnas, initialItems = 20, incrementSize = 20}) => {
    return (
        <section
            style={{
                width: '100%',
                overflow: 'hidden',
                position: 'relative',
            }}
        >
            <List
                height={altura || 600} // Altura del contenedor
                itemCount={cantidadTotal} // Renderizar solo los visibles
                itemSize={largoItem || 30} // Altura de cada fila
                width="100%"
                // onScroll={handleScroll}
                style={{
                    overflowX: 'hidden',
                    scrollbarWidth: 'thin',
                    msOverflowStyle: 'none'
                }}
            >
                {({ index, style }) => (
                    <section
                        className="contents row"
                        key={index}
                        style={{
                            ...style,
                            width: '100%',
                            display: 'grid',
                            alignItems:'center',
                            gridTemplateColumns: anchoColumnas || '5% 5% 15% 30% 15% 30%'
                        }}
                    > 
                        { children({ index, style })}
                    </section>
                )}
            </List>
        </section>
    );
}